import styled from 'styled-components';

const StyledImageLinkImage = styled.img `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 1;
  transition-property: opacity;
  transition-duration: ${props => props.theme.animation.duration.quick1};
  transition-timing-function: ${props => props.theme.animation.easing.productive.standard};
`;
const StyledImageLinkImageOverlay = styled(StyledImageLinkImage) `
  opacity: 0;
`;
const StyledImageLink = styled.a `
  display: block;
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  cursor: pointer;
  overflow: hidden;
  flex-shrink: 0;
  background-color: ${({ backgroundColor }) => backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : 'transparent'};
  transition-property: background-color;
  transition-duration: ${props => props.theme.animation.duration.quick1};
  transition-timing-function: ${props => props.theme.animation.easing.productive.standard};

  @media (pointer: fine) {
    &:hover {
      background-color: ${({ backgroundHoverColor }) => backgroundHoverColor !== null && backgroundHoverColor !== void 0 ? backgroundHoverColor : 'transparent'};

      ${StyledImageLinkImage} {
        opacity: 0;
      }

      ${StyledImageLinkImageOverlay} {
        opacity: 1;
      }
    }
  }
`;

export { StyledImageLink, StyledImageLinkImage, StyledImageLinkImageOverlay };
//# sourceMappingURL=HoverableImageLink.styles.mjs.map
